export default __webpack_public_path__ + "static/hero-title-e1f2c2a1712420cec7c313e49a55774e.png";